import React from 'react'

const InstantLoanCollectionReport = () => {
  return (
    <div>
      
    </div>
  )
}

export default InstantLoanCollectionReport
